import React, { useEffect, useState } from "react";
import formatDateAndTime from "../../common/formatDateAndTime";
import { Box, Modal } from "@mui/material";
import Commonmodal from "../../common/Commonmodal";

const Nrks = ({ summaryDetails }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [deliveryNrks, setDeliveryNrks] = useState([]);
  const [pickupNrks, setPickupNrks] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null); 

  const handleImageClose = () => {
    setImageSelection(null);
    setOpenImage(false);
  };

  const handleImageOpen = (url) => {
    setImageSelection(url);
    setOpenImage(true);
  };

  const normalizeToArray = (data) => {
    if (!data) return [];
    return Array.isArray(data) ? data : [data];
  };

  const getDeliveryNrks = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/deliverynrks?bookingId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setDeliveryNrks(normalizeToArray(data?.entities?.rows));
      } else {
        setDeliveryNrks([]);
      }
    } catch (error) {
      console.error("Error fetching Delivery NRKs:", error);
      setDeliveryNrks([]);
    }
  };

  const getPickupNrks = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/pickupnrks?bookingId=${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPickupNrks(normalizeToArray(data?.entities?.rows));
      } else {
        setPickupNrks([]);
      }
    } catch (error) {
      console.error("Error fetching Pickup NRKs:", error);
      setPickupNrks([]);
    }
  };

  useEffect(() => {
    if (summaryDetails?.id) {
      getDeliveryNrks(summaryDetails?.id);
      getPickupNrks(summaryDetails?.id);
    }
  }, [summaryDetails?.id]);

  return (
    <>
      {openImage && (
        <Commonmodal
          open={openImage}
          onClose={handleImageClose}
          url={imageSelection}
        />
      )}
      <div className="p-6">
        <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
          Trip Start & End ( NRK ) Details
        </h2>

        {/* Delivery NRKs Table */}
        <div className="overflow-hidden rounded-lg shadow mb-8">
          <div className="w-full text-left bg-white">
            <div className="bg-[#34495e] text-white">
              <h1 className="px-6 py-4 text-left">
                Trip start ( Delivery NRK ) Details
              </h1>
            </div>

            <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
              <table className="min-w-full text-sm text-left">
                <thead className="text-black">
                  <tr>
                    <th className="p-2">Executive Name</th>
                    <th className="p-2">Comments</th>
                    <th className="p-2">Starting Odometer</th>
                    <th className="p-2">Ending Odometer</th>
                    <th className="p-2">NRK Difference</th>
                    <th className="p-2">Image</th>
                    <th className="p-2">Fuel Volume</th>
                    <th className="p-2">Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryNrks.length > 0 ? (
                    deliveryNrks.map((item) => (
                      <tr key={item?.id} className="border-b hover:bg-gray-50">
                        <td className="p-2">
                          {item?.fleetExecutiveName || "-"}
                        </td>
                        <td className="p-2">{item?.fuelComment || "-"}</td>
                        <td className="p-2">
                          {item?.startingOdometer + " / kms" || "-"}
                        </td>
                        <td className="p-2">
                          {item?.endingOdometer > 0 ? item?.endingOdometer + " / kms" : "0 / Kms"  || "-"}
                        </td>
                        <td className="p-2">
                          {item?.endingOdometer -
                            item?.startingOdometer +
                            " / km" || "-"}
                        </td>
                        <td className="p-2">
                          {item?.image ? (
                            <img
                              onClick={() => {
                                handleImageOpen(item?.image);
                              }}
                              className="h-10 w-10 cursor-pointer"
                              alt="NRK"
                              src={item?.image}
                            />
                          ) : (
                            "No Image"
                          )}
                        </td>
                        <td className="p-2">
                          {item?.startingFuelVolume + " %" || "-"}
                        </td>
                        <td className="p-2">
                          {formatDateAndTime(item?.createdOn)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center p-4 text-gray-500">
                        No NRK's found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="overflow-hidden rounded-lg shadow mb-8">
          <div className="w-full text-left bg-white">
            <div className="bg-[#34495e] text-white">
              <h1 className="px-6 py-4 text-left">
                Trip End ( Pickup NRK ) Details
              </h1>
            </div>

            <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
              <table className="min-w-full text-sm text-left">
                <thead className="text-black">
                  <tr>
                    <th className="p-2">Executive Name</th>
                    <th className="p-2">Comments</th>
                    <th className="p-2">Starting Odometer</th>
                    <th className="p-2">Ending Odometer</th>
                    <th className="p-2">NRK Difference</th>
                    <th className="p-2">Image</th>
                    <th className="p-2">Fuel Volume</th>
                    <th className="p-2">Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {pickupNrks.length > 0 ? (
                    pickupNrks.map((item) => (
                      <tr key={item?.id} className="border-b hover:bg-gray-50">
                        <td className="p-2">
                          {item?.fleetExecutiveName || "-"}
                        </td>
                        <td className="p-2">{item?.fuelComment || "-"}</td>
                        <td className="p-2">
                          {item?.startingOdometer + " / kms" || "-"}
                        </td>
                        <td className="p-2">
                          {item?.endingOdometer > 0 ? item?.endingOdometer + " / kms" : "0 / Kms"}
                        </td>
                        <td className="p-2">
                          {item?.endingOdometer -
                            item?.startingOdometer +
                            " / km" || "-"}
                        </td>
                        <td className="p-2">
                          {item?.image ? (
                            <img
                              onClick={() => {
                                handleImageOpen(item?.image);
                              }}
                              className="h-10 w-10 cursor-pointer"
                              alt="NRK"
                              src={item?.image}
                            />
                          ) : (
                            "No Image"
                          )}
                        </td>
                        <td className="p-2">
                          {item?.startingFuelVolume + " %" || "-"}
                        </td>
                        <td className="p-2">
                          {formatDateAndTime(item?.createdOn)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center p-4 text-gray-500">
                        No NRK's found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nrks;
